<template>
	<div>
		<div class="current-values" v-for="(data, index) in data.user_moves" :key="data.id">
			<h3>Última Mudanza</h3>
			<div class="ctn-action-btns">
				<v-tooltip top v-if="!data.editableFlag" >
					<template v-slot:activator="{ on, attrs }">
						<v-btn icon color="primary" small @click="updateDataAction(data, index)" v-bind="attrs" v-on="on"><v-icon>mdi-content-save</v-icon></v-btn>
					</template>
					<span>Editar</span>
				</v-tooltip>
				<v-tooltip top v-if="data.editableFlag">
					<template v-slot:activator="{ on, attrs }">
						<v-btn icon  small @click="data.editableFlag = false" v-bind="attrs" v-on="on"><v-icon>mdi-pencil</v-icon></v-btn>
					</template>
					<span>Editar</span>
				</v-tooltip>
				<v-tooltip top v-else>
					<template v-slot:activator="{ on, attrs }">
						<v-btn icon color="error" small @click="data.editableFlag = true" v-bind="attrs" v-on="on"><v-icon>mdi-cancel</v-icon></v-btn>
					</template>
					<span>Cancelar</span>
				</v-tooltip>
				<v-tooltip top>
					<template v-slot:activator="{ on, attrs }">
						<v-btn icon small @click="deleteData(data)" v-bind="attrs" v-on="on"><v-icon>mdi-delete</v-icon></v-btn>
					</template>
					<span>Eliminar</span>
				</v-tooltip>
			</div>
			<br/>
			<v-form
					:ref="'form'+index"
					v-model="data.valid"
					lazy-validation
			>
				<label for="">Fecha y hora de mudanza</label>

				<v-dialog
						ref="dialog"
						v-model="data.modal"
						persistent
						width="340px"
				>
					<template v-slot:activator="{ on, attrs }">
						<v-text-field
								v-model="data.datetime"
								max="10"
								label=""
								readonly
								v-bind="attrs"
								v-on="on"
								:rules="validationRules.required"
								:disabled="data.editableFlag "
						></v-text-field>
					</template>
					<v-date-picker v-model="data.datetime" scrollable>
						<v-spacer></v-spacer>
						<v-btn text color="primary" @click="data.modal = false">Cancel</v-btn>
						<v-btn text color="primary" @click="data.modal = false">OK</v-btn>
					</v-date-picker>
				</v-dialog>
				<label for="">País de mudanza</label>
				<v-select
						v-model="data.country"
						:items="countries"
						item-text="country"
						item-value="country"
						placeholder="Selecciona un pais"
						:rules="validationRules.required"
						:disabled="data.editableFlag "
				></v-select>
				<label for="">Estado o departamento de mudanza</label>
				<v-select
						v-model="data.place"
						:items="countries2[data.country]"
						menu-props="auto"
						:rules="validationRules.required"
						placeholder="Selecciona un estado"
						required
						:disabled="data.editableFlag || !countries2[data.country]"
				></v-select>
			</v-form>
		</div>
		<div class="new-child" v-if="newData.flag">
			<h3>Agregar mudanza</h3>
			<v-form
					ref="newForm"
					v-model="newData.valid"
					lazy-validation
			>
				<label for="">Fecha y hora de mudanza</label>
				<v-dialog
						ref="dialog"
						v-model="modalNew"
						persistent
						width="340px"
				>
					<template v-slot:activator="{ on, attrs }">
						<v-text-field
								readonly
								v-bind="attrs"
								v-on="on"
								v-model="newData.datetime"
								:rules="validationRules.required"
								dateFormat="yyyy-MM-dd"
								placeholder=""
								required
						></v-text-field>
					</template>
					<v-date-picker v-model="newData.datetime" scrollable @input="modalNew = false"  >
						<v-spacer></v-spacer>
						<v-btn text color="primary" @click="modalNew = false">Cancel</v-btn>
						<v-btn text color="primary" @click="modalNew = false">OK</v-btn>
					</v-date-picker>
				</v-dialog>
				<label for="">País de mudanza</label>
				<v-select
						v-model="newData.country"
						:items="countries"
						item-text="country"
						item-value="country"
						placeholder="Selecciona un pais"
						required
						:rules="validationRules.required"
				></v-select>
				<label for="">Estado o departamento de mudanza</label>
				<v-select
						v-model="newData.place"
						:items="countries2[newData.country]"
						:rules="validationRules.required"
						placeholder="Selecciona un estado"
						required
						:disabled="!newData.country"
				></v-select>
			</v-form>
			<v-btn color="primary" outlined class="save-btn" @click="newData.flag = false">
				Cancelar
			</v-btn>
			<v-btn color="primary" class="save-btn ml-4" @click="saveNewData" :disabled="!newData.valid || !newData.datetime">
				Guardar cambios
			</v-btn>
		</div>
		<div class="ctn-btn" v-if="!newData.flag && !data.user_moves.length">
			<v-btn fab color="teal" dark small @click="newData.flag = true">
				<v-icon dark>mdi-plus</v-icon>
			</v-btn>
			<label @click="newData.flag = true">Agregar</label>
		</div>
		<v-dialog v-model="dialog" persistent max-width="350">
			<v-card>
				<v-card-title class="headline">Eliminar registro</v-card-title>
				<v-card-text>
					¿Realmente desea eliminar el registro?
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="primary" text @click="confirmDeleteData(currentData.id)">Borrar</v-btn>
					<v-btn color="gray" text @click="dialog = false">Cancelar</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
  import {mapActions, mapState} from "vuex";
  import {phones} from "../assets/js/phones.js"
  import {countries} from "../assets/js/countries.js"
  import {countries2} from "../assets/js/countries2.js"
  export default {
    name: "Moves.vue",
    data() {
      return {
        modal: false,
				modalNew: false,
        phones: phones,
        countries: countries,
        countries2: countries2,
        newData: {
          names: "",
          flag: false
        },
        showConfirm: false,
        dialog: false,
        currentData: {},
        validationRules: {
          required: [
            v => !!v || 'Debe ingresar un valor para este campo',
          ],
        },
        maxDate: new Date()
      }
    },
    computed: {
      ...mapState('moves',[
        'data']),
      states() {
        let country = countries.filter((item) => { return item.country == this.newData.country})
        if (!country.length) { country = [{}]}
        return country
      },
    },
    methods : {
      ...mapActions(
          'moves', [
            'fetchData',
            'removeData',
            'addData',
            'updateData',
          ]
      ),
      ...mapActions(['loaderChange']),
      saveNewData () {
        let valid = this.$refs.newForm.validate()
        if (valid) {
          this.loaderChange(true)
          this.addData(this.newData).finally(() => {
            this.loaderChange(false)
            this.newData.flag = false
            this.resetNewData()
          })
        }
      },
      resetNewData() {
        this.newData.names = ""
        this.newData.surnames = ""
        this.newData.date = ""
        this.newData.country = ""
        this.newData.place = ""
      },
      deleteData(data) {
        this.currentData = data
        this.dialog = true
      },
      confirmDeleteData(data) {
        this.dialog = false
        this.loaderChange(true)
        this.removeData(data).finally(() => {
          this.loaderChange(false)
        })
      },
      updateDataAction (data, index) {
        let valid = this.$refs[`form${index}`][0].validate()
        if (valid) {
          this.loaderChange(true)
          this.updateData(data).finally(() => {
            this.loaderChange(false)
            data.editableFlag = true
          })
        }
      }
    }
  }
</script>

<style lang="scss" scoped>

	@mixin mobile {
		@media screen and (max-width: 768px) {
			@content;
		}
	}
	::v-deep .v-input {
		width: 250px;
		.v-messages__message {
			padding-top: 3px;
		}
		&.v-input--is-disabled {
			.v-input__slot::before {
				display: none;
			}
			.v-input__append-inner {
				display: none;
			}
			.v-text-field__details {
				display: none;
			}
		}
		.v-text-field__details {
			min-height: 0;
			.v-messages, .v-text-field__details {
				min-height: 0;
			}
		}
		.v-input__slot {
			margin-bottom: 0;
			.v-text-field__slot, .v-select__selections {
				input, .v-select__selection {
					color: #656565;
				}
			}
		}

	}
	::v-deep .v-date-picker-header__value button {
		text-transform: uppercase;
		font-size: 14px;
		margin-top: 2px;
	}
	.ctn-btn {
		font-weight: 200;
		margin-top: 20px;
		::v-deep .v-btn {
			background-color: #2C8886;
		}
		label {
			margin-left: 12px;
			vertical-align: middle;
			font-weight: 200;
		}
	}
	.save-btn {
		margin: 35px 0 20px;
		text-transform: none;
		font-size: 12px;
		width: 160px;
		border-radius: 7px;
		height: 40px;
		&.cancel {
			margin-left: 12px;
		}
	}
	h3	{
		font-size: 16px;
		font-weight: 800;
		margin-bottom: 8px;
		margin-top: 12px;
		color: #656565;
	}
	.current-values {
		position: relative;
		display: inline-block;
		width: 100%;
		.ctn-action-btns {
			display: inline-block;
			position: absolute;
			top: 8px;
			right: 0;
		}
	}
	::v-deep .v-picker__body {
		width: 100% !important;
		.accent--text button, td .v-btn__content {
			color: #656565;
		}
	}
	.save-btn.ml-4 {
		@include mobile {
			margin-left: auto !important;
		}
	}
</style>
